<template>
  <div class="winess-check-cla">
    <div class="tab-cla">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="$t('witnessRecord.checkRecord')"
          name="checkRecord"
        ></el-tab-pane>
        <el-tab-pane
          :label="$t('witnessRecord.personRecord')"
          name="personRecord"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <checkRecord v-if="activeName === 'checkRecord'"></checkRecord>
      <personRecord v-if="activeName === 'personRecord'"></personRecord>
    </div>
  </div>
</template>

<script>
import checkRecord from './witness/checkRecord'
import personRecord from './witness/personRecord'

export default {
  components: {
    checkRecord,
    personRecord
  },
  provide() {
    return {
      statusList: this.statusList,
      hasTemperature: this.hasTemperature,
      hasMask: this.hasMask,
      hasVerifyMode: this.hasVerifyMode,
      hasStatus: this.hasStatus
    }
  },
  data() {
    return {
      activeName: 'checkRecord',
      deviceVerifyMode: {
        0: this.$t('verifyintModel.0'),
        1: this.$t('verifyintModel.1'),
        4: this.$t('verifyintModel.4'),
        10: this.$t('verifyintModel.10'),
        15: this.$t('verifyintModel.15'),
        16: this.$t('verifyintModel.16'),
        18: this.$t('verifyintModel.18'),
        19: this.$t('verifyintModel.19'),
        30: this.$t('verifyintModel.30'),
        31: this.$t('verifyintModel.31'),
        32: this.$t('verifyintModel.32'),
        33: this.$t('verifyintModel.33'),
        34: this.$t('verifyintModel.34'),
        200: this.$t('verifyintModel.200')
      },
      statusList: [
        {
          key: 0,
          label: this.$t('witnessRecord.checkFail')
        },
        {
          key: 1,
          label: this.$t('witnessRecord.checkSuccess')
        },
        {
          key: 2,
          label: this.$t('witnessRecord.bornPerson')
        }
      ]
    }
  },
  methods: {
    hasTemperature(val) {
      if (val && val !== '255') {
        return [
          'span',
          {
            class: parseInt(val) >= 37.3 ? 'error__color' : 'normal__color'
          },
          val
        ]
      } else {
        return ['span', {}, 'N/A']
      }
    },
    hasMask(val) {
      if (val && val !== '255') {
        let res =
          val === '0'
            ? this.$t('witnessRecord.no')
            : this.$t('witnessRecord.yes')
        return ['span', {}, res]
      } else {
        return ['span', {}, 'N/A']
      }
    },
    hasVerifyMode(val) {
      return ['span', {}, this.deviceVerifyMode[val]]
    },
    hasStatus(val) {
      let result = []
      result = this.statusList.filter(item => {
        return item.key === parseInt(val)
      })
      return result.length !== 0
        ? ['span', {}, result[0].label]
        : ['span', {}, 'N/A']
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.error__color {
  color: @ststusFailed;
}
.normal__color {
  color: @statusSuccess;
}
.winess-check-cla {
  .header_tool_cla {
    /deep/ .el-tabs__header {
      margin: 0 0 3px 0;
    }
  }
  .black_panel_cla {
    min-height: 500px;
  }
  /deep/.el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }
  .tab-cla {
    position: relative;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 2px;
    padding: 10px;
  }

  .top-tab-cla {
    padding: 5px 15px;
    line-height: 1.5;
    cursor: pointer;
  }
  .checked {
    color: @themeColor;
    border-bottom: 2px solid;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/witnessCheck.vue